import {Typography,TextField,Button} from '@mui/material'
import { useState ,useRef} from 'react';
import {commentPost} from '../../../actions/posts'
import { useDispatch } from 'react-redux'

const CommentSection = ({post}) => {
    
    const dispatch = useDispatch();                   //getting the dispatch function
    const [comments, setComments] = useState(post?.comments);   //state to store the comments of a specific post
    const [comment, setComment] = useState('');      //state for our comment input
    const commentsRef = useRef();                   //useRef function to hook to a specific element

    const handleClick = async ()=>{     //function to handle the button 
        const userComment = `${JSON.parse(localStorage.getItem('profile'))?.result.name} : ${comment}` ;
        // dispatch commentPost action , the action returns the comments from db so we can but them on the comments state
        const newComments = await dispatch(commentPost(userComment,post._id)) ;
        setComments(newComments);      
        setComment('');       //clear the comment input
        commentsRef.current.scrollIntoView({ behavior: 'smooth' });     // auto scroll to the submited comment
    }
  return (  //showing our comment section using material ui
    <div>
        <div style={{display: 'flex', justifyContent: 'space-between',}}>
            <div style={{height: '200px', overflowY: 'auto', marginRight: '30px'}}>
                <Typography variant='h6' gutterBottom>Comments</Typography>
                {comments.map((c , i)=>(
                     <Typography key={i} variant='subtitle1' gutterBottom>
                         <strong>{c.split(': ')[0]}</strong> : {c.split(':')[1]}  {/* user: comment ,(split to make the user name bold but not the comment) */}
                     </Typography>   
                ))}
            <div ref={commentsRef} />   {/* last comment ref anchor point for auto scroll */}
            </div>
            {/* if user is loogged allow him to comment , if not don't show the form */}
            {JSON.parse(localStorage.getItem('profile'))?.result.name && (
            <div style={{width: '70%'}}>
               <Typography variant='h6' gutterBottom>Write a Comment</Typography> 
               <TextField multiline label='Comment' value={comment} onChange={(e)=>{setComment(e.target.value)}} fullWidth rows={4} variant='outlined'/>
               <Button style={{marginTop:'10px'}} onClick={handleClick} fullWidth disabled={!comment} variant='contained' color='primary' >Comment</Button>     
            </div>  )}
        </div>
    </div>
  )
}

export default CommentSection